import React from 'react';
import PropTypes from 'prop-types';

import { AspectRatioCard } from '@homeaway/react-aspect-ratio-card';
import './SearchCard.less';

const CNAME = 'SearchCard';

const SearchCard = ({
  searchTerm,
  departureDate,
  arrivalDate,
  searchButton,
  aspectRatio,
  ...otherProps
}) => (
  <AspectRatioCard
    aspectRatio={aspectRatio}
    {...otherProps}
  >
    <div data-slot={'figure'} className={`${CNAME}__content`}>
      <h4 className="h4">{searchTerm}</h4>
      {(departureDate && arrivalDate) && <span className="small">{`${arrivalDate} – ${departureDate}`}</span>}
    </div>
    <div data-slot="caption">{searchButton}</div>
  </AspectRatioCard>
);

SearchCard.propTypes = {
  aspectRatio: PropTypes.string.isRequired,
  searchTerm: PropTypes.string.isRequired,
  departureDate: PropTypes.string,
  arrivalDate: PropTypes.string,
  searchButton: PropTypes.element
};

SearchCard.defaultProps = {
  aspectRatio: '4x3',
  searchTerm: ''
};

export default SearchCard;
